import { Skeleton, ErrorPanel } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetFleetDriversQuery } from "@/redux/apis/driver/driverApi";
import { ArchivedDriversTable } from "./ArchivedDriversTable";
import { useGetArchivedDriversParams } from "./hooks/useGetArchivedDriversParams";

export const ArchivedDriversPanel = () => {
  const { params } = useGetArchivedDriversParams();
  const { isFetching, data: response, error } = useGetFleetDriversQuery(params, { refetchOnMountOrArgChange: true });

  if (error) return <ErrorPanel messages={getErrorMessages(error)} />;
  if (isFetching || !response) return <Skeleton />;

  return (
    <>
      <ArchivedDriversTable items={response.data.drivers} page={response.data.page} />
      <ArchivedDriversTable.Pagination page={response.data.page} />
    </>
  );
};
